import React from "react";
import Mydata from "@/app/data/blog/chicago-Ohare.json";
function hero() {
  const Data = Mydata[3];
  return (
    <div className="mx-auto max-w-5xl px-4 text-[#2B3252] text-lg">
      {Data.Mainheading.map((section, index) => (
        <div key={index} className="">
          {/* Main Title */}
          {section && (
            <h2 id={section.id} className="blogtitle">{section.title}</h2>
          )}
          {/* Content Sections */}
          {section && <p className="blogcontent">{section.content}</p>}
          {section && <p className="blogcontent">{section.content1}</p>}
          
          {section.terminal && (
            <h3 id={section.id} className="blogSubtitle">{section.terminal}</h3>
          )}
          {section.image && (
            <img src={section?.image} alt={section.title} className="mb-3 rounded-[20px]" />
          )}

          {/* Additional Content Sections */}
          {section && (
  <p
    className="blogcontent"
    dangerouslySetInnerHTML={{ __html: section.content2 }}
  />
)}

{section && (
  <p
    className="blogcontent"
    dangerouslySetInnerHTML={{ __html: section.content3 }}
  />
)}
 {/* Render content4 safely using dangerouslySetInnerHTML */}
 {section && section.content4 && (
        <p
          className="blogcontent"
          dangerouslySetInnerHTML={{ __html: section.content4 }} // Correct format
        />
      )}


     

          {/* Bulletpoints List */}
          {section.bulletpoints && (
            <ul className="pl-4">
              {section.bulletpoints.map((bullet, bulletIndex) => (
                <li key={bulletIndex} className=" ">
                  {bullet}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
}


export default hero;
